import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import announcer from './aria-announcer';

const $navMobilePanel = document.querySelector('.nav-mobile-panel');
const $btnMobileMenu = document.querySelector('.btn-mobile');
const $btnMenuItem = document.querySelectorAll('.nav-mobile-menu-btn');
const $btnSubmenuBack = document.querySelectorAll('.nav-mobile-submenu-back');
const $navMobileMenu = document.querySelector('.nav-mobile-panel');

$btnMobileMenu?.addEventListener('click', () => {
    $btnMobileMenu.classList.toggle('open');
    $navMobilePanel.classList.toggle('open');

    if ($btnMobileMenu.getAttribute('aria-expanded') === 'false') {
        $btnMobileMenu.setAttribute('aria-expanded', 'true');
        announcer.announce('Le menu mobile est ouvert');
        disableBodyScroll($navMobileMenu, {
            allowTouchMove: (el) => el.closest('.nav-mobile-panel') !== null,
        });
    } else {
        $btnMobileMenu.setAttribute('aria-expanded', 'false');
        announcer.announce('Le menu mobile est fermé');
        enableBodyScroll($navMobileMenu);
    }
});

// Add click event listeners to show submenus
$btnMenuItem.forEach((btnMenuItem) => {
    btnMenuItem.addEventListener('click', () => {
        const $currentSubmenu = btnMenuItem.nextElementSibling;
        btnMenuItem.setAttribute('aria-expanded', 'true');
        $currentSubmenu.setAttribute('aria-hidden', 'false');
        $currentSubmenu.classList.add('open');
        $currentSubmenu.focus();
        announcer.announce(`Le sous-menu ${btnMenuItem.textContent} est ouvert`);
    });
});

// Submenus back buttons
$btnSubmenuBack.forEach((btnSubmenuBack) => {
    btnSubmenuBack.addEventListener('click', () => {
        const $parentSubmenu = btnSubmenuBack.closest('.main-nav-mobile-submenu');
        const $btnParentSubmenu = $parentSubmenu.previousElementSibling;

        $btnParentSubmenu.setAttribute('aria-expanded', 'false');
        $btnParentSubmenu.focus();
        requestAnimationFrame(() => {
            $parentSubmenu.setAttribute('aria-hidden', 'true');
            $parentSubmenu.classList.remove('open');
        });

        announcer.announce(`Le sous-menu ${btnSubmenuBack.textContent} est fermé`);
    });
});
